<tran-ui-content-section>
    <div class="flex flex-col pt-[80px] pb-[104px] gap-[64px]">
        <div class="flex flex-col !gap-4 lg:pl-[25%] lg:pr-[18.75%]">
            <h3 class="font-bold text-topline-l uppercase">
                {{ 'home.building-organization.subtitle' | translate }}
            </h3>
            <h2 class="text-hero-l2">
                {{ 'home.building-organization.title' | translate }}
            </h2>
        </div>
        <div class="flex flex-wrap md:flex-row gap-[40px] justify-center">
            @for (tile of HOME_TILES; track tile.icon) {
                <div class="flex flex-col text-left !p-4 bg-deep-blue-800 rounded-lg w-[290px] min-h-[280px] gap-6">
                    <div class="text-[56px] text-bold-green" [class]="tile.icon"></div>
                    <div class="flex flex-col gap-4">
                        <h4 class="font-bold text-hero-xs-4">
                            {{ tile.title | translate }}
                        </h4>
                        <p class="text-copy-xs">
                            {{ tile.description | translate }}
                        </p>
                    </div>
                </div>
            }
        </div>
    </div>
</tran-ui-content-section>
